import React, { Component } from 'react';
import {
  Tabs,
  Tab,
  TabPanel,
  TabList
} from 'react-re-super-tabs';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TabSellingProperties from '../TabSellingProperties/TabSellingProperties';
import TabPrivateBrokerage from '../TabPrivateBrokerage/TabPrivateBrokerage';
import TabEstateBoard from '../TabEstateBoard/TabEstateBoard';
import TabVirtualTour from '../TabVirtualTour/TabVirtualTour';

import * as styles from './NavTabs.scss';

const styleTab = {
  padding: '10px 10px',
  display: 'inline-flex',
  cursor: 'pointer',
  width: '20vw',
  color: '#231F20',
  textAlign: 'center',
  fontSize: '24px',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Assistant'
};

const styleActiveTab = {
  ...styleTab,
  color: '#FFFFFF',
  background: '#04AAEB 0% 0% no-repeat padding-box',
  border: 'solid #04AAEB 1px',
  margin: '2px 0 0',
  borderRadius: '31px 31px 0px 0px'
};

const tabId = {
  exposure: 'internationalExposure',
  allAds: 'allAdsTogether',
  advertisements: 'noAdvertisements',
  virtual: 'virtualTour'
};

class NavTabs extends Component {
  handleClick = (event) => {
    const hiddenElement = event.currentTarget;
    hiddenElement.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'center' });
  }

  customTab = (event) => (
    <span
      onClick={this.handleClick}
      style={event.isActive ? styleActiveTab : styleTab}
      className={styles.tab}
    >
      {event.children}
    </span>
  );

  render() {
    const translate = this.props.translate('NavTabs');

    return (
      <div className={styles.tabsWrapper}>
        <Tabs activeTab={tabId.exposure}>
          <TabList id="tabList" className={styles.tabs}>
            <Tab
              component={this.customTab}
              label={translate(tabId.exposure, 'label')}
              id={tabId.exposure}
            />
            <Tab
              component={this.customTab}
              label={translate(tabId.allAds, 'label')}
              id={tabId.allAds}
            />
            <Tab
              component={this.customTab}
              label={translate(tabId.advertisements, 'label')}
              id={tabId.advertisements}
            />
            <Tab
              component={this.customTab}
              label={translate(tabId.virtual, 'label')}
              id={tabId.virtual}
            />
          </TabList>
          <TabList>
            <TabPanel component={TabSellingProperties} id={tabId.exposure} />
            <TabPanel component={TabEstateBoard} id={tabId.allAds} />
            <TabPanel component={TabPrivateBrokerage} id={tabId.advertisements} />
            <TabPanel component={TabVirtualTour} id={tabId.virtual} />
          </TabList>
        </Tabs>
      </div>
    );
  }
}

NavTabs.propTypes = {
  translate: PropTypes.func
};


export default NavTabs;
